<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="handlingapprovingmodal"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
    @ok="handlingapprovingmodal"
    :title="title"
    ref="handlingapprovingmodal"
    :ok-disabled="submitted"
  >
    <p>{{ content }}</p>
  </b-modal>
</template>

<script>
import { notificationMixin } from "@/mixins/notification";
export default {
  mixins: [notificationMixin],
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
    };
  },
  props: [
    "content",
    "module",
    "title",
    "data",
    "isRoute",
    "RoutePlace",
    "type",
    "route_history",
  ],
  methods: {
    async handlingapprovingmodal() {
      this.submitted = true;
      await this.$store.dispatch(this.module, this.data).then((result) => {
        this.submitted = false;
        if (
          result.data.type != "" &&
          result.data.status != "1" &&
          result.data.status != "0"
        ) {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: result.data.status,
            type: result.data.type,
            showCloseButton: true,
          });
        }
        if (result.status == 200) {
          this.$emit("setSuccessHandlingModal", result);
          if (this.route_history) {
            this.$router.push(this.route_history);
          } else {
            this.$router.push({
              name: this.RoutePlace,
            });
          }
        }
      });
      await this.$refs.handlingapprovingmodal.hide();
    },
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
};
</script>

<style>
</style>
